<template>
  <div class="upload-view">
    <div class="upload-toolbar">
      <button class="clear-task-btn" @click="onClearTask">清空任务</button>
    </div>

    <div class="product-type-banner" role="group" aria-label="商品类型选择">
      <div class="banner-stripe"></div>
      <div class="banner-body">
        <div class="banner-header">
          <span class="banner-tag">重要</span>
          <span class="banner-title">商品类型</span>
          <span class="banner-desc">选错会导致生成结果不符合预期</span>
        </div>
        <div class="type-cards">
          <button
            type="button"
            class="type-card"
            :class="{ active: workbench.isWomenClothing }"
            @click="workbench.setIsWomenClothing(true)"
          >
            <span class="type-card-radio"></span>
            <span class="type-card-name">女装</span>
          </button>
          <button
            type="button"
            class="type-card"
            :class="{ active: !workbench.isWomenClothing }"
            @click="workbench.setIsWomenClothing(false)"
          >
            <span class="type-card-radio"></span>
            <span class="type-card-name">通用商品</span>
          </button>
        </div>
      </div>
    </div>

    <div v-for="(product, idx) in workbench.products" :key="product.id" class="product-row-wrapper">
      <ProductRow :product="product" :productIndex="idx" />
    </div>
  </div>
</template>

<script setup>
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import ProductRow from '@/components/upload/ProductRow.vue'

const workbench = useWorkbenchStore()

const onClearTask = () => {
  if (!confirm('确定要清空当前任务吗？\n\n所有产品（A/B/C）的上传图片都会被删除，且无法恢复。')) return
  workbench.clearAllTask()
}
</script>

<style scoped>
.upload-view {
  gap: 6px;
  margin-top: -28px;
}

.upload-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px 2px;
  gap: 1rem;
  flex-wrap: wrap;
}
.clear-task-btn {
  border: 1px solid var(--border-strong);
  background: var(--bg-white);
  color: var(--text-body);
  border-radius: var(--radius-sm);
  padding: 0.4rem 1rem;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all var(--dur-fast) var(--ease-out);
}
.clear-task-btn:hover {
  border-color: var(--primary-color);
  color: var(--primary-active);
  background: var(--primary-softer);
}

/* 商品类型横幅 */
.product-type-banner {
  position: relative;
  display: flex;
  margin: 0 24px 10px;
  background: var(--caramel-50);
  border: 1px solid var(--caramel-200);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}
.banner-stripe {
  flex-shrink: 0;
  width: 4px;
  background: var(--primary-gradient);
}
.banner-body {
  flex: 1;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.banner-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.banner-tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  background: var(--primary-gradient);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  letter-spacing: 0.04em;
}
.banner-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-title);
}
.banner-desc {
  font-size: 12.5px;
  color: var(--text-body);
}

.type-cards {
  display: inline-flex;
  gap: 8px;
  margin-left: auto;
}
.type-card {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 6px 14px;
  background: var(--bg-white);
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text-body);
  transition: all var(--dur-fast) var(--ease-out);
}
.type-card:hover {
  border-color: var(--primary-color);
  background: var(--primary-softer);
}
.type-card.active {
  border-color: var(--primary-color);
  background: var(--primary-soft);
  color: var(--primary-active);
  box-shadow: var(--shadow-primary);
}
.type-card-radio {
  flex-shrink: 0;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 2px solid var(--border-strong);
  background: #fff;
  position: relative;
  transition: all var(--dur-fast) var(--ease-out);
}
.type-card.active .type-card-radio {
  border-color: var(--primary-color);
}
.type-card.active .type-card-radio::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--primary-color);
}

@media (max-width: 720px) {
  .upload-view {
    margin-top: 0;
  }
  .type-cards {
    margin-left: 0;
    width: 100%;
  }
}
</style>
